import { CrudPage, type Field, type Column } from "../components/CrudPage";

const fields: Field[] = [
  { name: "name", label: "Name", type: "text", required: true },
  { name: "email", label: "Email", type: "email" },
  { name: "phone", label: "Phone", type: "tel" },
  { name: "address", label: "Address", type: "text" },
  {
    name: "coverageArea",
    label: "Coverage area",
    type: "tags",
    placeholder: "Barrie, Orillia, Gravenhurst",
    help: "Comma-separated",
  },
  {
    name: "capabilities",
    label: "Capabilities",
    type: "tags",
    placeholder: "commercial, floor care, post-construction",
    help: "Comma-separated",
  },
  {
    name: "insuranceExpiry",
    label: "Insurance expires",
    type: "date",
    help: "Phase 4 will email a reminder before this date",
  },
  { name: "wsibExpiry", label: "WSIB expires", type: "date" },
  { name: "notes", label: "Notes", type: "textarea" },
];

const columns: Column[] = [
  { name: "name", label: "Name" },
  { name: "phone", label: "Phone" },
  { name: "coverageArea", label: "Covers" },
  { name: "capabilities", label: "Capabilities" },
  { name: "insuranceExpiry", label: "Insurance" },
  { name: "wsibExpiry", label: "WSIB" },
];

export function Cleaners() {
  return (
    <CrudPage
      resource="cleaners"
      title="Cleaners"
      fields={fields}
      columns={columns}
      emptyHint="The cleaners you work with, with their coverage area and insurance dates."
    />
  );
}
